<template>
  <div class="tab-content-four__container">
    
    <!-- head -->
    <div class="content__head">
      <h2 class="content__head-title">{{ upgradingAndReconstruction.title }}</h2>
      <p class="content__head-text" v-html="$convertPxToRem(upgradingAndReconstruction.content)"></p>
    </div>

    <!-- help -->
    <div class="content__help flex">
      <!-- left -->
      <div class="content__help-item content__help-left"></div>
      <!-- right -->
      <div class="content__help-item content__help-right">
        <div class="content__help-right-body">
          <!-- title -->
          <h2 class="content__help-title">{{ upgradingAndReconstruction.group1.title }}</h2>
          <!-- desc -->
          <p class="content__help-desc">{{ upgradingAndReconstruction.group1.subTitle }}</p>
          <!-- txt list -->
          <ul class="content__help-txt-list">
            <li class="content__help-txt-item" v-for="(txt, idx) in upgradingAndReconstruction.group1.help_txt_list" :key="idx">
              <span>●</span>
              <span>{{ txt }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- rights -->
    <div class="content__rights flex f-center">
      <!-- left -->
      <div class="content__rights-left">
        <div class="content__rights-one">
          <h2 class="content__rights-title">{{ upgradingAndReconstruction.rights_list1_title }}</h2>
          <p class="content__rights-desc" v-for="txt,i in upgradingAndReconstruction.rights_list1" :key="i">
            <span>●</span>
            <span>{{ txt }}</span>
          </p>
        </div>
        <div class="content__rights-two">
          <h2 class="content__rights-title">{{ upgradingAndReconstruction.rights_list2_title }}</h2>
          <p class="content__rights-desc" v-for="(txt, i) in upgradingAndReconstruction.rights_list2" :key="i">
            <span>●</span>
            <span>{{ txt }}</span>
          </p>
        </div>
      </div>
      <!-- right -->
      <div class="content__rights-right"></div>
    </div>

    <!-- img01 -->
    <div class="content__img-one"></div>
    <footer-wrap></footer-wrap>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'TabContentFour',

    data() {
        return {
          
        }
    },

    computed: {
      ...mapGetters([
        'currentLang'
      ]),
      upgradingAndReconstruction() {
        return this.currentLang.config.customerServicePage.upgradingAndReconstruction
      },
    },

    created() {

    },

    methods: {}
}
</script>

<style scoped lang="scss">
.content__head {
  width: 1000px;
  height: auto;
  margin: 50px auto 80px;
  text-align: center;

  h2 {
    color: #323232;
    font-weight: normal;
    margin-bottom: 30px;
    font-size: 30px;
  }

  p {
    color: #777777;
  }

  .content__head-text {
    line-height: 1.8;
    font-size: 18px;
    color: #777;
    text-align: justify;
    text-align-last: center;
  }
}


.content__help {
  width: 100%;
  min-height: 550px;
  background-color: #F5F5F5;

  .content__help-item {
    // width: 50%;
    flex: 1;
  }

  .content__help-right-body {
    // max-width: 520px;
    margin-left: 50px;
  }

  .content__help-left {
    width: 100%;
    height: 550px;
    background: url("../../../../assets/images1/customer_service/khfw19.jpg") no-repeat scroll;
    background-position: center top;
    background-size: cover;
  }

  .content__help-title {
    margin: 60px 0 60px;
    font-weight: 500;
    color: #0F335E;
    letter-spacing: 1px;
  }

  .content__help-desc {
    margin-bottom: 40px;
    font-size: 18px;
    color: #777;
    text-align: justify;
    line-height: 1.9;
  }

  .content__help-txt-item {
    margin-top: 15px;
    color: #777;
    line-height: 1.5;
    font-size: 18px;
  }
}

.content__rights {
  width: 100%;
  height: 580px;
  background-color: #fff;

  .content__rights-left {
    max-width: 700px;
    margin-right: 160px;
  }

  .content__rights-one {
    margin-bottom: 50px;
  }
  .content__rights-title {
    margin-bottom: 20px;
    font-weight: 500;
    letter-spacing: 1px;
    color: #0F335E;
  }

  .content__rights-desc {
    margin-top: 15px;
    color: #777;
    line-height: 1.8;
    font-size: 18px;
    text-align: justify;
  }

  .content__rights-right {
    width: 274px;
    height: 250px;
    background: url("../../../../assets/images1/customer_service/khfw20.png") no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }
}

.content__img-one {
  height: 450px;
  background: url("../../../../assets/images1/customer_service/khfw21.jpg") no-repeat scroll;
  background-position: center center;
  background-size: cover;
}
</style>


// WEBPACK FOOTER //
// src/pages/home/home_customer_service/components/TabContentFour.vue